module.exports = __webpack_public_path__ + "img/shoulderseam_small.27a181db.png";